import { gql } from '@apollo/client';

export const FETCH_APP_DATA = gql`
    query FetchAppData($lng: String) {
        glassesPackages(company: PBE, glassesType: REGULAR, lng: $lng) {
            id
            name
            nameNl
            default
            multifocal
            borderless
            backgroundColorGeneral
            textColorGeneral
            priceInt
            canBeOrdered
            order
            imageUrl
            imageDescLeft
            imageDescRight
            topChoice
            featureIds
            addOns {
                id
                name
                description
                order
                priceInt
                excludesAddOnIds
                freeWithPackagesIds
            }
        }
        features(company: PBE, glassesType: REGULAR, lng: $lng) {
            id
            name
            order
            displayBold
            url
            multifocalOnly
        }
    }
`;
